import React from 'react';

const LoggedOut = () => {
  const params = new URLSearchParams(window.location.search);
  const logo = params.get('logo');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-custom-white_light">
      {logo && (
        <img src={logo} alt="logo" className="h-16 w-auto mb-6" />
      )}
      <h1 className="text-2xl font-semibold mb-2">You have been logged out</h1>
      <p className="text-gray-600 mb-6 text-center">
        Your session has ended. To continue, please sign in again.
      </p>
      <a
        className="menu-button"
        href="/api/microsoft/login"
      >
        Log in again
      </a>
    </div>
  );
};

export default LoggedOut;


